#import "./AssetFields.graphql"

mutation UpdateAsset($id: ID!, $attributes: AssetAttributesInput!) {
  updateAsset(input: { id: $id, attributes: $attributes }) {
    asset {
      ...AssetFields
    }
  }
}
